import { Directive, ElementRef, Input } from "@angular/core";
import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator
} from "@angular/forms";

import { AtlasFormElement } from "@shared/schemas/atlas-form-element";

@Directive({
	selector: "[appAtlasFormElement]",
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: AtlasFormElementValidatorDirective,
			multi: true
		}
	],
	standalone: false
})
export class AtlasFormElementValidatorDirective implements Validator {
	@Input() isCustomValidation = false;

	private atlasElement: AtlasFormElement;

	constructor(private element: ElementRef) {
		this.atlasElement = element.nativeElement as AtlasFormElement;
	}

	validate(control: AbstractControl): ValidationErrors | null {
		if (this.isCustomValidation) {
			return null;
		}

		const isValid = control.touched
			? this.atlasElement.reportValidity()
			: this.atlasElement.checkValidity();

		if (isValid) return null;

		return this.atlasElement.getValidationsReport();
	}
}
